exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#loader{width:100%;height:100%;position:fixed;z-index:100;text-align:center;top:113px}#loader #loader-mask{width:100%;height:100%;opacity:.6}#loader #loader-spinner{width:80px;height:80px;margin-left:-40px;margin-top:-153px}#loader #loader-spinner .circle{border-width:3px}", ""]);

